import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      loadUserData();
    } else {
      setLoading(false);
    }
  }, [token]);

  const loadUserData = async () => {
    try {
      const storedUser = localStorage.getItem('user');
      const storedAccount = localStorage.getItem('account');
      if (storedUser && storedAccount) {
        setUser(JSON.parse(storedUser));
        setAccount(JSON.parse(storedAccount));
      }
    } catch (error) {
      console.error('Failed to load user data:', error);
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const response = await axios.post(`${API}/auth/login`, { email, password });
    const { token, user, account } = response.data;
    
    setToken(token);
    setUser(user);
    setAccount(account);
    
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('account', JSON.stringify(account));
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    
    return response.data;
  };

  const register = async (email, password, name, accountName) => {
    const response = await axios.post(`${API}/auth/register`, {
      email,
      password,
      name,
      account_name: accountName
    });
    const { token, user, account } = response.data;
    
    setToken(token);
    setUser(user);
    setAccount(account);
    
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('account', JSON.stringify(account));
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    
    return response.data;
  };

  const updateAccount = (updates) => {
    setAccount(prev => {
      const updated = { ...prev, ...updates };
      localStorage.setItem('account', JSON.stringify(updated));
      return updated;
    });
  };

  const refreshAccount = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return null;
      const res = await axios.get(`${API}/account/status`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAccount(prev => {
        // O estado de acesso (PROMPT 201) vem junto: o PlanGate decide por ele.
        const updated = { ...prev, subscription_status: res.data.subscription_status, acesso: res.data.acesso || null };
        localStorage.setItem('account', JSON.stringify(updated));
        return updated;
      });
      return res.data;
    } catch (e) {
      console.error('refreshAccount error:', e);
      return null;
    }
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    setAccount(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('account');
    delete axios.defaults.headers.common['Authorization'];
  };

  return (
    <AuthContext.Provider value={{ user, account, loading, login, register, logout, updateAccount, refreshAccount }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);